import { parseCsv } from '@plebiscito/plebiscito/helpers'

export const internationalCsv = `N_KEY;GLOSA_ZONA;COD_ZONA;ORDEN_ZONA;LABEL
t.p.alemania;ALEMANIA;8000;1;ALEMANIA
t.p.argentina;ARGENTINA;8001;2;ARGENTINA
t.p.australia;AUSTRALIA;8002;3;AUSTRALIA
t.p.austria;AUSTRIA;8003;4;AUSTRIA
t.p.belgica;BELGICA;8004;5;BÉLGICA
t.p.bolivia;BOLIVIA;8005;6;BOLIVIA
t.p.brasil;BRASIL;8006;7;BRASIL
t.p.canada;CANADA;8007;8;CANADÁ
t.p.colombia;COLOMBIA;8008;9;COLOMBIA
t.p.corea;COREA;8009;10;COREA
t.p.costarica;COSTA RICA;8010;11;COSTA RICA
t.p.croacia;CROACIA;8011;12;CROACIA
t.p.cuba;CUBA;8012;13;CUBA
t.p.dinamarca;DINAMARCA;8013;14;DINAMARCA
t.p.ecuador;ECUADOR;8014;15;ECUADOR
t.p.egipto;EGIPTO;8015;16;EGIPTO
t.p.ellibano;EL LIBANO;8016;17;EL LíBANO
t.p.elsalvador;EL SALVADOR;8017;18;EL SALVADOR
t.p.emiratosarabesunidos;EMIRATOS ARABES UNIDOS;8018;19;EMIRATOS ÁRABES UNIDOS
t.p.espana;ESPAÑA;8019;20;ESPAÑA
t.p.estadosunidos;ESTADOS UNIDOS;8020;21;ESTADOS UNIDOS
t.p.federacionrusa;FEDERACION RUSA;8021;22;FEDERACIÓN RUSA
t.p.filipinas;FILIPINAS;8022;23;FILIPINAS
t.p.finlandia;FINLANDIA;8023;24;FINLANDIA
t.p.francia;FRANCIA;8024;25;FRANCIA
t.p.grecia;GRECIA;8025;26;GRECIA
t.p.guatemala;GUATEMALA;8026;27;GUATEMALA
t.p.haiti;HAITI;8027;28;HAITÍ
t.p.honduras;HONDURAS;8028;29;HONDURAS
t.p.hungria;HUNGRIA;8029;30;HUNGRÍA
t.p.india;INDIA;8030;31;INDIA
t.p.indonesia;INDONESIA;8031;32;INDONESIA
t.p.irlanda;IRLANDA;8032;33;IRLANDA
t.p.israel;ISRAEL;8033;34;ISRAEL
t.p.italia;ITALIA;8034;35;ITALIA
t.p.jamaica;JAMAICA;8035;36;JAMAICA
t.p.japon;JAPON;8036;37;JAPÓN
t.p.jordania;JORDANIA;8037;38;JORDANÍA
t.p.kenia;KENIA;8038;39;KENIA
t.p.malasia;MALASIA;8039;40;MALASIA
t.p.marruecos;MARRUECOS;8040;41;MARRUECOS
t.p.mexico;MEXICO;8041;42;MÉXICO
t.p.nicaragua;NICARAGUA;8042;43;NICARAGUA
t.p.noruega;NORUEGA;8043;44;NORUEGA
t.p.nuevazelanda;NUEVA ZELANDA;8044;45;NUEVA ZELANDA
t.p.paisesbajos;PAISES BAJOS;8045;46;PAÍSES BAJOS
t.p.panama;PANAMA;8046;47;PANAMÁ
t.p.paraguay;PARAGUAY;8047;48;PARAGUAY
t.p.peru;PERU;8048;49;PERÚ
t.p.polonia;POLONIA;8049;50;POLONIA
t.p.portugal;PORTUGAL;8050;51;PORTUGAL
t.p.reinounido;REINO UNIDO;8051;52;REINO UNIDO
t.p.republicacheca;REPUBLICA CHECA;8052;53;REPÚBLICA CHECA
t.p.republicadominicana;REPUBLICA DOMINICANA;8053;54;REPÚBLICA DOMINICANA
t.p.republicapopularchina;REPUBLICA POPULAR CHINA;8054;55;REPÚBLICA POPULAR CHINA
t.p.rumania;RUMANIA;8055;56;RUMANÍA
t.p.singapur;SINGAPUR;8057;57;SINGAPUR
t.p.sudafrica;SUDAFRICA;8058;58;SUDÁFRICA
t.p.suecia;SUECIA;8059;59;SUECIA
t.p.suiza;SUIZA;8060;60;SUIZA
t.p.tailandia;TAILANDIA;8061;61;TAILANDIA
t.p.turquia;TURQUIA;8062;62;TURQUíA
t.p.uruguay;URUGUAY;8063;63;URUGUAY
t.p.venezuela;VENEZUELA;8064;64;VENEZUELA
t.p.vietnam;VIETNAM;8065;65;VIETNAM`

export default parseCsv(internationalCsv)
